require('./blocks/big-action.less');
require('./blocks/sale-action.less');
require('./blocks/action-detail.less');
require('./blocks/product/product');
require('./blocks/action-limit.less');
require('./blocks/filter-price/filter-price.less');
require('./blocks/filter/filter.less');
require('./blocks/catalog.js');
require('./blocks/catalog.less');
require('./blocks/action-detail.js');



// WEBPACK FOOTER //
// ./sale_and_promo_detail.js